__turbopack_context__.v({
  "column": "XrgC6a_column",
  "columnHeading": "XrgC6a_columnHeading",
  "heading": "XrgC6a_heading",
  "root": "XrgC6a_root",
});
